import { createColumnHelper } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import type { DeskTableFeatures } from "@/modules/shell/data-table";
import type { BranchRow } from "@/shared/api/branches";

const columnHelper = createColumnHelper<DeskTableFeatures, BranchRow>();

export type BranchColumnsOpts = {
  savingName: boolean;
  editingId: string | null;
  editName: string;
  setEditName: (v: string) => void;
  onStartEdit: (row: BranchRow) => void;
  onCancelEdit: () => void;
  onSaveRename: () => void;
};

export function branchColumns(opts: BranchColumnsOpts) {
  return columnHelper.columns([
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      size: 220,
      cell: ({ row }) => {
        const b = row.original;
        if (opts.editingId === b.id) {
          return (
            <label className="block text-xs text-[var(--color-muted)]">
              Name
              <Input
                className="mt-1"
                value={opts.editName}
                onChange={(e) => opts.setEditName(e.target.value)}
                autoFocus
                disabled={opts.savingName}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    opts.onSaveRename();
                  }
                  if (e.key === "Escape") {
                    opts.onCancelEdit();
                  }
                }}
              />
            </label>
          );
        }
        return <div className="font-medium">{b.name}</div>;
      },
    }),
    columnHelper.accessor("slug", {
      id: "slug",
      header: "Slug",
      size: 160,
      cell: (info) => (
        <span className="font-mono text-xs text-[var(--color-muted)]">
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.display({
      id: "actions",
      header: "",
      size: 140,
      enableSorting: false,
      enableResizing: false,
      cell: ({ row }) => {
        const b = row.original;
        const editing = opts.editingId === b.id;
        if (editing) {
          return (
            <div className="flex flex-wrap justify-end gap-1">
              <Button
                type="button"
                size="sm"
                pending={opts.savingName}
                pendingLabel="Saving…"
                disabled={!opts.editName.trim()}
                onClick={() => opts.onSaveRename()}
              >
                Save
              </Button>
              <Button
                type="button"
                size="sm"
                variant="ghost"
                disabled={opts.savingName}
                onClick={() => opts.onCancelEdit()}
              >
                Cancel
              </Button>
            </div>
          );
        }
        return (
          <div className="flex flex-wrap justify-end gap-1">
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() => opts.onStartEdit(b)}
            >
              Edit
            </Button>
          </div>
        );
      },
    }),
  ]);
}
